<template>
  <div
    class="border-transparent border-t-current border-r-current rounded-full min-w-[20px] min-h-[20px] animate-spin"
    :style="{ borderWidth: `${thickness}px` }"
    :class="color"
  ></div>
</template>

<script setup lang="ts">
defineProps({
  thickness: {
    type: String,
    required: false,
    default: '2',
  },
  color: {
    type: String,
    required: false,
    default: 'text-primary-500',
  },
})
</script>
